import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { redirectSecondaryPage } from 'helpers/redirectSecondaryPage';

import LicensePage from 'components/pages/LicensePage';

export default LicensePage;

export const getServerSideProps = async props => {
  const redirect = redirectSecondaryPage(props);

  if (redirect) {
    return redirect;
  }

  return {
    props: {
      ...(await serverSideTranslations(props.locale, ['license'])),
    },
  };
};
